// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__23s28","errorLogs":"EditorFooter_errorLogs__2r9Pq"};